import {BaseCombo} from "./base_combo.js";

export class SingleCombo extends BaseCombo {
    constructor(dom) {
        super(dom);
    }

    _initializeArticleDoms() {
        this.articleDoms = Array.prototype.slice.call(this.dom.getElementsByClassName("combo_article"), 0);
    }

    addClickHandlers() {
        const links = this.dom.querySelectorAll("a");
        for (let i = 0; i < links.length; i++) {
            links[i].addEventListener("click", window.o_combo.trackHelper.clickHandlerForArticleClickTracking(i, this));
        }
        this.addClickHandlerForEek();
    }

    addClickHandlerForEek() {
        const energyEfficiencyLabels = this.dom.querySelectorAll(".combo_hasEnergyEfficiencyLabel");
        for (let index = 0; index < energyEfficiencyLabels.length; index++) {
            let energyEfficiencyLabel = energyEfficiencyLabels[index];
            energyEfficiencyLabel.addEventListener("click", () => {
                this._openEnergyEfficiencyLayer(
                    energyEfficiencyLabel.getAttribute("data-image-url"),
                    energyEfficiencyLabel.getAttribute("data-category"),
                    energyEfficiencyLabel.getAttribute("data-title"),
                    o_global.pali)
            });
        }
    }

    sendViewTracking() {
        window.o_combo.trackHelper.trackViewForCombo(this, this.articles, this.articleCount);
    }

    _openEnergyEfficiencyLayer(dataImageUrls, category, component, pali) {
        const dataImageUrlArray = dataImageUrls.split(",");

        const title = `<h2 class="p_layer__headline">${component}</h2>`
        const energyEfficiencyLayer =
            `<div class="combo_energyEfficiencyImageLayer">` +

            dataImageUrlArray.map(dataImageUrl =>
                `<picture>` +
                `<source srcset="${dataImageUrl}&fmt=webp" type="image/webp">` +
                `<img src="${dataImageUrl}" class="combo_energyEfficiencyImageLayer__image" alt="Energy efficiency class: ${category}"/>` +
                `</picture>`
            ) + `</div>`;

        let modalContentHTML;
        if (component !== null) {
            if (component.length > 0) modalContentHTML = title + energyEfficiencyLayer
        } else {
            modalContentHTML = energyEfficiencyLayer
        }

        const options = {
            modal: true,
            width: "550px",
            height: "585px",
            content: modalContentHTML,
            createTrackingContext: false
        };

        const layer = new pali.layerBuilder(options);
        layer.open();
    }
}
